import { Payment } from './../../models/payment';
import { Component, OnInit } from '@angular/core';
import { PaymentService } from '../../utils/services/payment.service';
import { ActivatedRoute, NavigationEnd, Router, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss'],
})
export class PaymentsComponent implements OnInit {
  public payments: Payment[];
  public title = 'All Payments';
  public navigationSubscription: Subscription;
  public dataSubscription: Subscription;
  constructor(
    private readonly paymentService: PaymentService,
    private readonly activeRoute: ActivatedRoute,
    private readonly router: Router
  ) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.loadData();
      }
    });
  }

  loadData() {
    this.payments = [];
    this.dataSubscription = this.activeRoute.params
      .pipe(
        map((params: Params) => {
          console.log(params);
          return `${params['path']}`;
        }),
        mergeMap((path) => {
          console.log(path);
          this.title = this.getTitle(path);
          return this.paymentService.getPaymentsList(path);
        })
      )
      .subscribe(
        (payments) => {
          this.payments = payments;
        },
        (err) => {
          console.error(err);
        }
      );
  }

  ngOnInit(): void {}

  getTitle(path: string) {
    switch (path) {
      case 'all':
        return 'All Payments';
      case 'payment':
        return 'Orders - Payment';
      case 'fulfillment':
        return 'Orders - Fulfillment';
      default:
        break;
    }
  }
}
